import { render } from "./FridgeDetailsSelectDateBarItem.vue?vue&type=template&id=61265e4f&scoped=true&ts=true"
import script from "./FridgeDetailsSelectDateBarItem.vue?vue&type=script&lang=ts"
export * from "./FridgeDetailsSelectDateBarItem.vue?vue&type=script&lang=ts"

import "./FridgeDetailsSelectDateBarItem.vue?vue&type=style&index=0&id=61265e4f&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61265e4f"]])

export default __exports__